import type { UseLeanMutationResult, UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import { logisticCloneQuery } from './graphql'
import type { SetOptional } from 'type-fest'
import type { CloneLogisticServiceArgs, Logistic } from '@ztechapps/common.contract'

export type CloneLogisticsResults = { cloneLogistic: Logistic }

export const useCloneLogistic = ({
  query,
  ...rest
}: SetOptional<UseMutationProps, 'query'> = {}): UseLeanMutationResult<
  CloneLogisticsResults,
  CloneLogisticServiceArgs
> => {
  query = query ?? logisticCloneQuery

  const [mutate, , mutationResult] = useMutation<CloneLogisticsResults, CloneLogisticServiceArgs>({ query, ...rest })

  const update = ({ logisticId }: CloneLogisticServiceArgs) => {
    return mutate({ input: { logisticId } })
  }

  return [update, mutationResult]
}
